import getScrollParent from './getScrollParent.js';
import getParentNode from './getParentNode.js';
import getNodeName from './getNodeName.js';
import getWindow from './getWindow.js';
import isScrollParent from './isScrollParent.js';
export default function listScrollParents(element, list) {
  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = getNodeName(scrollParent) === 'body';
  var win = getWindow(scrollParent);
  var target = isBody
    ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : [])
    : scrollParent;
  var updatedList = list.concat(target);
  return isBody
    ? updatedList // $FlowFixMe: isBody tells us target will be an HTMLElement here
    : updatedList.concat(listScrollParents(getParentNode(target)));
}
